"use client";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { BodyText } from "../../../foundation/typography/index.js";
import { forwardRef } from "react";
import classNames from "classnames";
import "../../../foundation/logos/Logo.css.js";
import { clickAnimation } from "../../../styles/animations.css.js";
import { focusStyle, stateLayers } from "../../../styles/states.css.js";
import { tokens } from "@gnist/themes/tokens.css.js";
import { Spinner } from "../../progress/Spinner.js";
import { chipRecipe } from "./styles.css.js";
import { actionText } from "../buttons/styles.css.js";
const ActionChip = forwardRef(function ActionChip2({ label, onClick, selected, icon, loading, density = "default", ...props }, ref) {
  return jsx("button", { type: "button", ...props, title: label, onClick, className: classNames(chipRecipe({
    selected,
    filterVariant: false,
    loading: loading == null ? void 0 : loading.isLoading
  }), clickAnimation, focusStyle, stateLayers({
    borderSize: "medium",
    borderRadius: "full",
    backgroundColor: "on-background",
    setFocusState: true
  })), ref, children: (loading == null ? void 0 : loading.isLoading) ? jsx(Spinner, { diameter: density === "compact" ? tokens.size.xs : tokens.size.s, textDescription: loading.loadingText }) : jsxs(Fragment, { children: [icon && jsx(Icon, { icon, size: density === "compact" ? "m" : "l" }), jsx(BodyText, { className: actionText, children: label })] }) });
});
export {
  ActionChip
};
